export default {
    model: {
        email: {
            label: "E-mail",
            placeholder: "Imię i nazwisko lub adres e-mail delegata",
            notFound: "Nie znaleziono użytkowników"
        },
        start_on: {
            label: "Data rozpoczęcia",
            placeholder: "Data rozpoczęcia delegowania"
        },
        end_on: {
            label: "Data zakończenia",
            placeholder: "Fakultatywny"
        },
        accept: {
            tip: "Delegując odpowiedzialność za zatwierdzanie, potwierdzasz, że bierzesz na siebie odpowiedzialność za wszelkie zamówienia zatwierdzone przez osobę, której delegujesz uprawnienia.",
            label: "Akceptuję"
        }
    },
    buttons: {
        submit: {
            cta: "Potwierdzać",
            processing: "Oszczędność"
        },
        close: {
            cta: "Anulować"
        }
    },
    saved: "Zapisano"
}